export const sem = [
    {
        semester: 'I st semester',
        to: '1sem'
    },
    {
        semester: 'II nd semester',
        to: '2sem'
    },
    {
        semester: 'III rd semester',
        to: '3sem'
    },
    {
        semester: 'IV th semester',
        to: '4sem'
    },
    {
        semester: 'V th semester',
        to: '5sem'
    },
    {
        semester: 'VI th semester',
        to: '6sem'
    },
    {
        semester: 'VII th semester',
        to: '7sem'
    },
    {
        semester: 'VIII th semester',
        to: '8sem'
    }
]